import React, { Fragment, useMemo, useState } from "react";
import { CURRENCY_SYMBOL } from "../../../constant";
import { Button } from "semantic-ui-react";
import { AiOutlineReload } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatNumber } from "../../../utils/formatNumber";
import LoadingEleWallet from "../../../components/Loading/LoadingEleWallet";
import NotFound from "../../../components/ProgressBlock/NotFound";
import { useNavigate } from "react-router";

const WalletCard = ({ eleWallet }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`profile.${key}`);

  const [buttonLoading, setButtonLoading] = useState(false);

  const memberData = useSelector((state) => state.isMemberInfo);

  const navigate = useNavigate();

  const handleReload = () => {
    setButtonLoading(true);

    setTimeout(() => {
      setButtonLoading(false);
    }, 2000);
  };

  return (
    <Fragment>
      {Object.keys(eleWallet || {})?.length === 0 ? (
        <NotFound />
      ) : (
        Object.keys(eleWallet || {})
          ?.sort((a, b) => eleWallet[b] - eleWallet[a])
          .map((wallet) => {
            return (
              <div
                key={wallet}
                className="py-[8px] px-[20px] bg-transaction-card dark:bg-base-light-black rounded-xl"
              >
                <div className="flex items-center justify-between">
                  <div className="flex flex-col justify-between">
                    <p className="text-transaction-text dark:text-base-white text-lg font-medium mb-0">
                      {formatNumber(eleWallet[wallet])} {CURRENCY_SYMBOL}
                    </p>
                    <p className="text-transaction-text dark:text-base-white text-sm mb-0">
                      <span className="font-bold text-lg">
                        {wallet.toUpperCase()}
                      </span>{" "}
                      {i18n("wallet")}
                    </p>
                  </div>
                  <div className="flex items-center gap-[10px]">
                    {/* <Button
                    type="button"
                    circular
                    loading={buttonLoading}
                    onClick={handleReload}
                    icon={<AiOutlineReload className="text-xl" />}
                    className="!bg-main-color !text-white !p-[5px]"
                  /> */}
                    <Button
                      onClick={() => {
                        navigate(`point-query/${wallet}`);
                      }}
                      type="button"
                      className="!bg-green-400 !text-white w-full "
                      content={i18n("transfer")}
                    />
                  </div>
                </div>
              </div>
            );
          })
      )}
    </Fragment>
  );
};

export default WalletCard;
